// extracted by mini-css-extract-plugin
export default {"groupList":"RoleAuthoritiesModal_groupList__8B1D-","groupName":"RoleAuthoritiesModal_groupName__edNqm"};